/**
 * SheetFooter — нижний бар редактора-шита (Отмена / Сохранить). Общий для
 * соло- и клиника-тел правки.
 */

import {Button} from '@components/ui/Button';

type SheetFooterProps = {
  disabled?: boolean;
  onClose: () => void;
  onSave: () => void;
};

export const SheetFooter = ({disabled, onClose, onSave}: SheetFooterProps) => (
  <div className="flex gap-2.5 border-t border-skr-line bg-card px-[18px] pb-6 pt-3">
    <Button variant="outline" className="h-[50px] rounded-[13px] px-5" onClick={onClose}>
      Отмена
    </Button>
    <Button className="h-[50px] flex-1 rounded-[13px]" disabled={disabled} onClick={onSave}>
      Сохранить
    </Button>
  </div>
);
